// extracted by mini-css-extract-plugin
export default {"container":"CGQAJ8LaNLSE4Of7qoeQ","title":"rSfgxkD2RAdiFPq8wOOT","footer":"OlScs0hhON7LTW9uGmZi","instruction":"bMWSfV_DXPWwWvs2kToX"};